import { MvShakaPlayer } from "@mv/shaka-video-player";
import { useEffect, useMemo, useRef, useState } from "react";
import Script from "react-load-script";

export interface ShakaProps {
  stream: string;
}

export const ShakaMediaPlayer = ({ stream }: ShakaProps) => {
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const [uiScriptLoaded, setUiScriptLoaded] = useState(false);

  const videoRef = useRef<HTMLVideoElement>(null);
  const videoContainerRef = useRef<HTMLDivElement>(null);

  const mvShakaPlayer = useMemo(() => {
    if (!scriptLoaded || !uiScriptLoaded) {
      return;
    }

    //@ts-expect-error
    return new MvShakaPlayer(console, window.shaka);
  }, [scriptLoaded, uiScriptLoaded]);

  const streamUrlWithoutToken = stream.split("?")[0];

  useEffect(() => {
    if (!mvShakaPlayer || !videoRef.current || !videoContainerRef.current) {
      return;
    }

    mvShakaPlayer.loadStream({
      stream,
      videoContainerElement: videoContainerRef.current,
      videoElement: videoRef.current,
    });
  }, [
    scriptLoaded,
    uiScriptLoaded,
    streamUrlWithoutToken, // note: explicitly using the url without token, since the token will change on each fetch
    mvShakaPlayer,
  ]);

  useEffect(() => {
    return mvShakaPlayer?.destroy;
  }, [mvShakaPlayer?.destroy]);

  return (
    <>
      <div
        ref={videoContainerRef}
        data-shaka-player-container
        data-shaka-player-cast-receiver-id="07AEE832"
        style={{
          height: "100%",
          backgroundColor: "#000",
        }}
      >
        {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
        <video
          data-testid="shaka-video-player-video-element"
          ref={videoRef}
          data-shaka-player
          id="video"
          style={{ width: "100%" }}
        />
      </div>

      <Script
        url={
          "https://cdnjs.cloudflare.com/ajax/libs/shaka-player/4.7.13/shaka-player.compiled.min.js"
        }
        onLoad={() => setScriptLoaded(true)}
      />

      <Script
        url={
          "https://cdnjs.cloudflare.com/ajax/libs/shaka-player/4.7.13/shaka-player.ui.min.js"
        }
        onLoad={() => setUiScriptLoaded(true)}
      />
    </>
  );
};
